<script lang="ts">
	import { Col, Row, Collapse, Accordion, AccordionItem } from "sveltestrap";
	import { FontAwesomeIcon } from "fontawesome-svelte";
	import { library } from "@fortawesome/fontawesome-svg-core";
	import { imageLightbox } from "../../../../../store/store";
	import {
		faCircleArrowUp as fasCircleArrowUp,
		faCircleArrowDown as fasCircleArrowDown,
	} from "@fortawesome/free-solid-svg-icons";
	import Lightbox from "../../../../../components/Lightbox/Lightbox.svelte";
	import { splitCamelCaseAndCapitalize } from "src/utils/misc";
	import BookingIssueCard from "./BookingIssueCard.svelte";
	export let tab;
	export let issues: any;

	const issueData = issues?.[tab];
	let modalOpen: boolean = false;
	let imageShowingIndex: number = 0;
	let isOpen = null;
	library.add(fasCircleArrowUp, fasCircleArrowDown);

	const handleImgClick = (i: number, image: string[]) => {
		imageLightbox.set([]);
		imageShowingIndex = Number(i);
		modalOpen = true;
		imageLightbox.set(image);
	};

	const handleIsOpen = (int) => {
		if (int === isOpen) {
			isOpen = null;
		} else {
			isOpen = int;
		}
	};
</script>

{#if modalOpen}
	<Lightbox on:click={() => (modalOpen = false)} {imageShowingIndex} />
{/if}
<Row>
	<Col xs={12}>
		<div>
			<Col>
				{#if issueData}
					{#if tab === "exterior"}
						{#each Object.keys(issueData) as key, i}
							{#if issueData[key].sides.length !== 0}
								<Accordion>
									<AccordionItem
										header={splitCamelCaseAndCapitalize(
											key
										)}
									>
										{#each issueData[key].sides as { createdAt, description, imageUrl, side }, index}
											<h5
												on:click={() =>
													handleIsOpen(
														`${i}` + `${index}`
													)}
												on:keyup={() => {}}
												style="cursor: pointer;"
												class="mb-2"
											>
												<b
													><i role="button"
														>{#if isOpen === `${i}` + `${index}`}
															<FontAwesomeIcon
																icon={fasCircleArrowUp}
															/>
														{:else}
															<FontAwesomeIcon
																icon={fasCircleArrowDown}
															/>
														{/if}
													</i>
													{splitCamelCaseAndCapitalize(
														side
													)}
												</b>
											</h5>
											<Collapse
												isOpen={isOpen ===
													`${i}` + `${index}`}
											>
												<BookingIssueCard
													{description}
													{createdAt}
													{imageUrl}
													{handleImgClick}
												/>
											</Collapse>
										{/each}
									</AccordionItem>
								</Accordion>
							{/if}
						{/each}
					{:else}
						{#each issueData as { createdAt, description, imageUrl }}
							<BookingIssueCard
								{description}
								{createdAt}
								{imageUrl}
								{handleImgClick}
							/>
						{/each}
					{/if}
				{:else}
					<div class="text-center">No issue data to show</div>
				{/if}
			</Col>
		</div>
	</Col>
</Row>

<style>
	:global(button.collapsed.accordion-button, button.accordion-button) {
		background: #011851 !important;
		color: white !important;
		/* border-radius: 8px !important; */
	}
	:global(
			button.collapsed.accordion-button::after,
			.accordion-button:not(.collapsed)::after
		) {
		background-image: url("data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='%23FFFFFF'><path fill-rule='evenodd' d='M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z'/></svg>");
	}

	:global(div.accordion-item) {
		border-radius: 8px !important;
		overflow: hidden;
	}
</style>
